/**
 * Shared CrewPilot hub filter-pill chrome (inline styles).
 *
 * Used by Estimate / Invoice / Project / Client hubs for status filter buttons.
 * Domain status colors remain in estimateStatusUi / invoiceStatusUi helpers.
 * Active/selected tints may still be applied locally per hub.
 */

export const HUB_STATUS_PILLS_WRAP_STYLE = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  marginBottom: "14px",
};

export const HUB_STATUS_PILL_BTN_BASE_STYLE = {
  borderRadius: "999px",
  padding: "8px 12px",
  fontSize: "12px",
  fontWeight: 800,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  cursor: "pointer",
  border: "1px solid var(--nx-border, #e2e5eb)",
  background: "var(--nx-surface2, #f8f9fb)",
  color: "var(--nx-text-muted, #5b6472)",
};

/** Common gold “selected / All” accent used across hubs. */
export const HUB_STATUS_PILL_ACTIVE_GOLD_STYLE = {
  border: "1px solid rgba(180, 140, 45, 0.5)",
  background: "rgba(180, 140, 45, 0.16)",
  color: "var(--nx-gold-ink, #8a6d23)",
};
